module.exports = __webpack_public_path__ + "static/media/litho-7.b67c154c.jpg";